import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import { Grade } from './grade';
import {GradesService} from '../grades.service';
import {Results} from '../../../core/results';
declare var $: any;
@Directive({
  selector: '[appGrade]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GradeDirective),
    multi: true
  }]

})
export class GradeDirective implements ControlValueAccessor, OnInit {

  @Input() private grade: Grade;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: GradesService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Highest academic level achieved',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<Grade>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.grade = JSON.parse(e.params.data.id);
      that.propagateChange(that.grade);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.grade = null;
      that.propagateChange(that.grade);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(grade: Grade): void {

    this.grade = grade;
    this.propagateChange(this.grade);
    const that = this;
    if (this.grade !== undefined && this.grade !== null) {
      const option = new Option(grade.name, JSON.stringify(grade), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.grade;
  }

  set value(v: any) {
    if (v !== this.grade) {
      this.grade = v;
      this.propagateChange(v);
    }
  }


}
